import { getPrintQuality } from "../utils/printQuality";

export function useOrderValidation({
  originalFile,
  img,
  canvasRef,
  grid,
  scale,
  setToast,
  setQualityModal,
  processOrder,
  loading,
}) {
  const handleFinishOrder = () => {
    if (loading) return;

    if (!originalFile) {
      setToast("Selecciona una imagen");
      return;
    }

    const printQuality = getPrintQuality({
      img,
      canvas: canvasRef.current,
      grid,
      scale,
    });

    if (printQuality === "bad") {
      setQualityModal({
        open: true,
        type: "bad",
      });

      return;
    }

    processOrder();
  };

  return {
    handleFinishOrder,
  };
}
